module.exports = __webpack_public_path__ + "static/img/6.df8eb3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/6.png
// module id = N4MD
// module chunks = 0